// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-navigation {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Helvetica", "Arial", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: 0;
}
.markdown-navigation::-webkit-scrollbar{
  width:0;
}

.markdown-navigation .title-anchor {
  display: block;
  color: #bbb;
  transition: all 0.2s;
  margin: 0.8em 0;
  font-weight: lighter;
  line-height: 2em;
  padding-right: 1.8em;
  cursor: pointer;
}

.markdown-navigation .title-anchor:hover,
.markdown-navigation .title-anchor.active {
  background-color: #f8f8f8;
  text-decoration: inherit;
}

.markdown-navigation .title-anchor.active {
  color: #007fff;
}

.markdown-navigation .title-anchor small {
  margin: 0 0.8em;
}

.markdown-navigation .title-level1 {
  color: #000;
  font-size: 1.2em;
  padding-left: 1em;
  font-weight: normal;
}

.markdown-navigation .title-level2 {
  color: #333;
  font-size: 1.1em;
  padding-left: 1em;
  font-weight: normal;
}

.markdown-navigation .title-level3 {
  color: #666;
  font-size: 1em;
  padding-left: 3em;
  font-weight: normal;
}

.markdown-navigation .title-level4 {
  color: #999;
  font-size: 0.9em;
  padding-left: 5em;
}

.markdown-navigation .title-level5 {
  color: #aaa;
  font-size: 0.9em;
  padding-left: 7em;
}

.markdown-navigation .title-level6 {
  color: #bbb;
  font-size: 0.9em;
  padding-left: 9em;
}

.markdown-sidebar {
  position: sticky;
  top: var(--right-rail-top-offset, 0px);

  max-height: calc(100vh - var(--right-rail-top-offset, 0px));
  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: thin;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/pages/navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,+KAA+K;EAC/K,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;;EAEtC,2DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;;EAElB,qBAAqB;EACrB,WAAW;AACb","sourcesContent":[".markdown-navigation {\n  font-size: 14px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Helvetica\", \"Arial\", \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"WenQuanYi Micro Hei\", sans-serif;\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  scrollbar-width: 0;\n}\n.markdown-navigation::-webkit-scrollbar{\n  width:0;\n}\n\n.markdown-navigation .title-anchor {\n  display: block;\n  color: #bbb;\n  transition: all 0.2s;\n  margin: 0.8em 0;\n  font-weight: lighter;\n  line-height: 2em;\n  padding-right: 1.8em;\n  cursor: pointer;\n}\n\n.markdown-navigation .title-anchor:hover,\n.markdown-navigation .title-anchor.active {\n  background-color: #f8f8f8;\n  text-decoration: inherit;\n}\n\n.markdown-navigation .title-anchor.active {\n  color: #007fff;\n}\n\n.markdown-navigation .title-anchor small {\n  margin: 0 0.8em;\n}\n\n.markdown-navigation .title-level1 {\n  color: #000;\n  font-size: 1.2em;\n  padding-left: 1em;\n  font-weight: normal;\n}\n\n.markdown-navigation .title-level2 {\n  color: #333;\n  font-size: 1.1em;\n  padding-left: 1em;\n  font-weight: normal;\n}\n\n.markdown-navigation .title-level3 {\n  color: #666;\n  font-size: 1em;\n  padding-left: 3em;\n  font-weight: normal;\n}\n\n.markdown-navigation .title-level4 {\n  color: #999;\n  font-size: 0.9em;\n  padding-left: 5em;\n}\n\n.markdown-navigation .title-level5 {\n  color: #aaa;\n  font-size: 0.9em;\n  padding-left: 7em;\n}\n\n.markdown-navigation .title-level6 {\n  color: #bbb;\n  font-size: 0.9em;\n  padding-left: 9em;\n}\n\n.markdown-sidebar {\n  position: sticky;\n  top: var(--right-rail-top-offset, 0px);\n\n  max-height: calc(100vh - var(--right-rail-top-offset, 0px));\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  scrollbar-width: thin;\n  z-index: 10;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
